import { Alert, Box, Button, Typography } from "@mui/material";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import DownloadIcon from "@mui/icons-material/Download";
import { AttachedDesignUpload } from "../../hooks/useAttachedDesignUpload";

interface Props {
  upload: AttachedDesignUpload | null;
  designLabel: string;
  isDownloading?: boolean;
  onDownload: () => void;
  onReplace: () => void;
}

const formatDate = (date: string) => {
  if (!date) return "";
  const parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime())) return "";
  return parsedDate.toLocaleDateString();
};

export const AttachedDesignUploadNotice = ({
  upload,
  designLabel,
  isDownloading = false,
  onDownload,
  onReplace,
}: Props) => {
  if (!upload) return null;

  const uploadedDate = formatDate(upload.date);

  return (
    <Alert
      severity="info"
      sx={{
        alignItems: "center",
        borderRadius: 1,
        mb: 2,
        "& .MuiAlert-message": { width: "100%" },
      }}
    >
      <Box
        sx={{
          alignItems: { xs: "flex-start", sm: "center" },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 1.5,
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Box>
          <Typography sx={{ fontWeight: 700 }} variant="body2">
            Uploaded PDF attached to this {designLabel}
          </Typography>
          <Typography color="text.secondary" variant="body2">
            {upload.customName}
            {uploadedDate ? ` - uploaded ${uploadedDate}` : ""}. Upload a new
            PDF to replace the default client download.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            justifyContent: { xs: "flex-start", sm: "flex-end" },
          }}
        >
          <Button
            disabled={isDownloading}
            onClick={onDownload}
            size="small"
            startIcon={<DownloadIcon />}
            variant="contained"
          >
            {isDownloading ? "Downloading" : "Download"}
          </Button>
          <Button
            onClick={onReplace}
            size="small"
            startIcon={<DriveFolderUploadIcon />}
            variant="outlined"
          >
            Replace file
          </Button>
        </Box>
      </Box>
    </Alert>
  );
};
